import { useEffect, useState } from "react";

import { fetchHospitalCounters, fetchHospitalResults } from "../api";
import type { HospitalResultsQuery, HospitalResultRow } from "../types";

export function useHospitalResults(query: HospitalResultsQuery) {
  const [rows, setRows] = useState<HospitalResultRow[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      setLoading(true);
      setError(null);
      try {
        const data = await fetchHospitalResults(query);
        if (cancelled) return;
        setRows(Array.isArray(data.items) ? data.items : []);
        setTotal(Number(data.total ?? 0));
      } catch (e: any) {
        if (!cancelled) {
          setError(String(e?.message || e || "Ошибка загрузки hospital-результатов"));
          setRows([]);
          setTotal(0);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    void load();
    return () => {
      cancelled = true;
    };
  }, [
    query.mis_id,
    query.department,
    query.doctor,
    query.hospital_type,
    query.from_date,
    query.to_date,
    query.limit,
    query.offset,
  ]);

  return { rows, total, loading, error } as const;
}

export function useHospitalCounters(query: HospitalResultsQuery) {
  const [fixedTransitions, setFixedTransitions] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      setLoading(true);
      setError(null);
      try {
        const data = await fetchHospitalCounters(query);
        if (cancelled) return;
        setFixedTransitions(Number(data.fix_transitions ?? 0));
      } catch (e: any) {
        if (!cancelled) {
          setError(String(e?.message || e || "Ошибка загрузки hospital-счетчика"));
          setFixedTransitions(0);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    void load();
    return () => {
      cancelled = true;
    };
  }, [
    query.mis_id,
    query.department,
    query.doctor,
    query.hospital_type,
    query.from_date,
    query.to_date,
  ]);

  return { fixedTransitions, loading, error } as const;
}
